import script from "./EducationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationItem.vue?vue&type=script&setup=true&lang=js"

import "./EducationItem.vue?vue&type=style&index=0&id=17807894&lang=scss"

const __exports__ = script;

export default __exports__